export const name = 'passcode';

export const Passcode = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      color="#161619"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66626 16.0088H21.3338"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M3.00366 11.9963L7.61616 9.31128"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M5.32129 13.3613V8.02881"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M7.7213 12.0488L3.0188 9.22876"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M20.9963 9.3562L16.3838 12.0412"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18.6787 7.99121V13.3237"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M16.2788 9.29614L20.9813 12.1236"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.37134 11.9963L13.9763 9.31128"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M11.6814 13.3613V8.02881"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M14.0812 12.0488L9.37866 9.22876"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
